import React, { useMemo, useState } from 'react';
import { Container, Form } from 'react-bootstrap';

import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';

import '../css/others/howtodo.css';

const HowToDo = () => {
  const [lang, setLang] = useState('en'); // 'en' | 'ta'

  const content = useMemo(() => {
    const en = {
      title: 'Registration of Documents',
      toc: [
        'Encumbrance Certificate (EC)',
        'Rate of Stamp Duty and Registration Fees',
        'Preparation Of Documents',
        'Presentation Of Documents',
        'Requirements for a Registration',
        'Field Inspection',
        'Certified Copies',
        'Will',
        'Special Category',
        'Market Value - Guidelines',
        'Fraudulent Registration - Remedies'
      ],
      intro:
        'Building their own house is a dream of human beings. Before deciding to purchase a property, ascertain the transactions and ownership effected in respect of the property proposed to be purchased by getting the Encumbrance Certificate as a first step.',
      sections: [
        {
          heading: 'EC',
          blocks: [
            {
              type: 'list',
              items: [
                'Encumbrance Certificate (EC) for the period from 1-1-1975 to till date can be downloaded. which comprises all the transaction pertaining to the given survey number. It is given for the informative purpose.',
                'For the period from 1-1-1975 to till date, application shall be submitted by online and the required payment also to be made by online (The system itself will show the required fees). The applied EC will be delivered to the user login with QR code and the digital signature of the Registering Officer within three working days excluding the date of application.',
                'If the selected village falls on different Sub Registrar offices for the different period, separate EC has to be applied for the different period.'
              ]
            }
          ]
        },
        {
          heading: 'Applying for EC',
          blocks: [
            {
              type: 'list',
              items: [
                'For getting EC before 1-1-1975(Manual period) manual application has to be given in the jurisdictional Sub Registrar office(SRO). The required fee can be paid either by net banking or using debit / credit card or through the PoS machine available in SRO. This application will be processed and signed EC will be delivered within 4 days. Applications are available at free of cost at Sub Registrar office or same can also download the required form from website',
                'Give maximum possible particulars of the property in the application to get EC without omission of entries.',
                'EC filter is created using the parameters such as Sub Registrar office, period, village, survey, sub-division number, plot number/flat number provided by public. Providing wrong or insufficient details will lead to delivering of wrong EC. Any application for refund of fee paid to the wrong EC will not be entertained. For example, if public provided plot number 4 instead of 5 then the entries relevant to the plot number 4 only will be delivered.'
              ]
            }
          ]
        },
        {
          heading: 'Fees',
          blocks: [
            {
              type: 'table',
              columns: ['Item', 'Amount'],
              rows: [
                ['E.C. Application Fee', 'Re.1/-'],
                ['Search Fee for the I year', 'Rs.30/-'],
                ['Search fee for every additional year', 'Rs. 10/-'],
                ['Additional Fees For the Computerised Period ie from 1987', 'Rs.200/-']
              ]
            }
          ]
        },
        {
          heading: 'Memo Documents',
          blocks: [
            {
              type: 'list',
              items: [
                'In the case of two properties of different jurisdiction registered in one office. A memo will be sent from the document registered office to the other office where the other property is situated for the period before 12.2.2018. From 12.2.2018, the document details will be reflected in both offices.'
              ]
            }
          ]
        },
        {
          heading: 'Closed Office EC',
          blocks: [
            {
              type: 'list',
              items: [
                'Some of the Sub Registrar offices were closed due to less number of Registrations and ECs can be applied to those offices also after 1.1.75 through our portal by selecting the closed SRO name. For the period before 1.1.75, EC application can be given to the SRO where the closed office is merged.'
              ]
            }
          ]
        },
        {
          heading: 'Index Correction Petition (ICP)',
          blocks: [
            {
              type: 'list',
              items: [
                'If any errors found in the details of the EC such as Survey Number, Name, Boundary, etc., a written petition has to be given manually to the respective Sub Registrar(SR) along with copy of the original document and EC. After due verification, SR will make the necessary corrections in entry. After corrections made by SR, then DR will approve the corrections. Once the corrections are approved, it will reflect in EC.'
              ]
            }
          ]
        },
        {
          heading: 'Rate of Stamp Duty and Registration Fee',
          blocks: [
            {
              type: 'table',
              columns: ['Categories of Document', 'Stamp Duty', 'Registration Fee'],
              rows: [
                ['1 Conveyance (Sale)', '7% on the market value of the property', '2% on the market value of property.'],
                ['2 Gift', '7% on the market value of the Property', '2% on the market value of the property.'],
                ['3 Exchange', '7% on the market value of the greater value.', '2% on the market value of greater value property.'],
                ['4 Simple Mortagage', '1% (on the loan amount) subject to a maximum of Rs 50,000/-', '1% on loan amount subject to a maximum of Rs.15,000/-'],
                ['5 Mortgage with possession', '4% on loan amount', '1% subject to the maximum of Rs.2,00,000/-'],
                ['6 Agreement to Sale', 'Rs.200', '1% on the money advanced (1% on total consideration if possession is given)'],
                [
                  '7 Agreement relating to construction of building',
                  '1% on the cost of the proposed construction or the value of construction or the consideration specified in the agreement whichever is higher',
                  '3% on the cost of the proposed construction or the value of construction or the consideration specified in the agreement whichever is higher'
                ],
                ['8 Cancellation', 'Rs.2000', 'Rs.2000'],
                [
                  '9 Partition (among family members)',
                  '1% on the market value of the property subject to a maximum of Rs.40000/- for each share',
                  '1% subject to a maximum of Rs.10000/- for each share.'
                ],
                ['9 Partition (among Non family members)', '4% on the market value of the property for separated shares', '1% on the market value of the property for separated shares'],
                [
                  '10 Power of Attorney (General to SELL immovable property, non family member)',
                  '1% on the market value of the property',
                  '1% on the market value of the property.'
                ],
                ['10 Power of Attorney (General to SELL immovable property, family member)', 'Rs. 2000', 'Rs.2,000'],
                ['10 Power of Attorney (SELL movable property & other purposes)', 'Rs. 2000', 'Rs.2000'],
                ['10 Power of Attorney (given for consideration)', '5% on the total market value of the property', '1% on the market value of the property'],
                [
                  '11 Settlement (in favour of family members)',
                  '1% On the market value of the property subject to a maximum of ₹ 40000/-',
                  '1% on the market value of the property subject to a maximum of Rs.10000/-'
                ],
                ['11 Settlement (Other Cases)', '7% on the market value of the property', '2% on the Market Value'],
                ['12 Partnership deed (capital ≤ Rs.500)', 'Rs. 50', '1% on the Capital invested'],
                ['12 Partnership deed (Other Cases)', 'Rs. 2000', '1% on the capital invested'],
                ['13 Memoradum of Deposit of Title Deeds', '0.5% on loan amount subject to a maximum of ₹ 40000/-', '1% on loan amount subject to a maximum of Rs 8000/-'],
                [
                  '14 Release (among family members)',
                  '1% on the market value of the property subject to a maximum of ₹ 40000/-',
                  '1% on the market value of the property subject to a maximum of ₹ 10000/-'
                ],
                ['14 Release (among non family members)', '7% on the market value of the property', '1% on the market value of the property'],
                ['15 Lease below 30 years', '1% on the total amount of rent, premium, fine etc', '1% subject to a maximum of Rs.40000/-'],
                ['15 Lease upto 99 years', '4% on the total amount of rent, premium, fine etc', '1% subject to a maximum of Rs.40000/-'],
                ['15 Lease above 99 years or perpetual Leave', '7% on the total amount of rent, fine, premium of advance, if any, payable.', '1% subject to a maximum of Rs.40000/-'],
                ['16 Declaration of Trust (if property is there, it would be considered as sale)', 'Rs. 2000', '1% on the Amount']
              ]
            },
            {
              type: 'para',
              text: 'Stamp Duty and Registration Fees can be paid in the following mode:'
            },
            {
              type: 'list',
              items: ['Conventional Stamp paper', 'ePayment', 'eStamp(within Corporation areas only)']
            },
            { type: 'subheading', text: 'STAMPS' },
            {
              type: 'list',
              items: [
                'They are licensed to sell stamps at the face value',
                'If any extra demand is made, action can be taken to cancel his license',
                'Stamp papers are also sold by Sub Registrars, Treasuries, and Assistant Superintendent of Stamps, Chennai',
                'Stamp duty may also be paid by online without any limit or by D.D. with a limit of Rs.5,000/-. The payment by online method has option to pay the Stamp Duty by way of RTGS / NEFT. In the portal in online payment screen the user has to choose RTGS / NEFT option. A challan will be generated and using this they can inform their bank to transfer the amount. Once, the amount transferred, user can generate acknowledgement from Registration Department website',
                'For registering documents in Chennai zone and other corporation areas e-stamping may also be used.'
              ]
            }
          ]
        },
        {
          heading: 'Preparation of Documents',
          blocks: [
            { type: 'subheading', text: 'DRAFTING OF DEEDS BY' },
            {
              type: 'list',
              items: [
                'Executants of the document: Citizen can use the facility of document creation in the website of Registration Department or the model deeds available on the registration website.',
                'Advocates.',
                'Licensed Document Writers.',
                'Chartered Accountants having Document Writing License'
              ]
            },
            { type: 'subheading', text: 'Entry of Abstract' },
            {
              type: 'list',
              items: [
                'If the document is not created using the utility provided in the portal, the key details such as executant, claimant, property details have to be entered in the Portal.'
              ]
            },
            { type: 'subheading', text: 'Booking of Tokens' },
            {
              type: 'list',
              items: [
                'Once the payment is made, citizen has to book the appointment with the Jurisdictional Sub Registrar, the token availability can be viewed in the below path in website:'
              ]
            }
          ]
        },
        {
          heading: 'Presentation of Documents',
          blocks: [
            { type: 'subheading', text: 'When to be presented for registration ?' },
            {
              type: 'list',
              items: [
                'Within four months from the date of execution.',
                'The District Registrar may condone delay of another four months with fine',
                'No time limit for Wills executed.'
              ]
            },
            { type: 'subheading', text: 'Fine for Delay in Presentation' },
            {
              type: 'table',
              columns: ['Sl.No', 'Delay', 'Fine'],
              rows: [
                ['1', 'Upto 1 week', '25 % of the registration fee'],
                ['2', 'Upto 1 month', '75 % of the registration fee'],
                ['3', 'Upto 4 month', '100 % of the registration fee']
              ]
            },
            { type: 'para', text: 'This is in addition to the required registration fees' },
            { type: 'subheading', text: 'Where to be presented for registration' },
            {
              type: 'list',
              items: [
                'Documents relating to immovable properties situated in Tamil Nadu shall be registered in Tamil Nadu only at the Sub-Registrar’s office under its jurisdiction, the property situates.',
                'Documents granting Power of attorney relating to immovable property can be presented for registration either at the Sub - Registrar’s office under its jurisdiction, the property situates or at the Sub-Registrar’s office within whose jurisdiction the Principal ordinarily resides.',
                'If more than one property is there in a document, then it can be registered either one of the Sub- Registrar office under its jurisdiction, the properties is situate.d',
                'Registration done out-side the state except Power of attorney with respect to the properties lying within Tamil Nadu is null and void.',
                "If you don’t know the jurisdiction of registration offices please ascertain it from the website by entering the street name or village name at Know Your Jurisdiction menu."
              ]
            }
          ]
        },
        {
          heading: 'Requirements',
          blocks: [
            {
              type: 'list',
              items: [
                'Duly executed document. With respect to sale deed claimant of the sale document also to sign in the sale deed and also appear before the registering officer for registration of the sale deed.',
                'In the case of deeds of sale, settlement, gift, exchange, partition, release and certificate of sale relating to immovable properties and if the property belongs to Natham land, then Patta Transfer application with court fee label of Rs.7/- duly filled and signed.',
                'If the value of property exceeds Rs.10/- lakhs, PAN/Form 60 shall be provided',
                'Acknowledgement for online payment of required registration fees, computer fees, sub-division fees etc. If the balance or required amount is below Rs.1,000/- and the party is willing to pay via PoS machine kept in Sub Registrar office, then charges can be made through either debit or credit card.',
                'Patta issued by the Revenue authority in case the property belongs to Natham land.',
                'Original ID card for executant, witnesses and claimant (for sale deed). The Photocopy(Xerox) of all the above ID card has to be attached with the original document. Only Aadhaar card, PAN card, Voter ID card, Driving Licence, Passport and Ration card will be accepted as ID proof.',
                'For the deeds of sale, settlement, exchange, gift, partition, release and certificate of sale and the property is layout, then layout drawing. If it is first plot document and not a resale, the copy of approval or regularisation order issued by either CMDA or DTCP.',
                'Original previous registration deed. If it is not found, then non-traceable certificate issued by the Police Department and advertisement given in the daily in this regard.',
                'If owner of the property is no more, then death and legal-heir certificate'
              ]
            },
            { type: 'subheading', text: 'Return of documents :' },
            {
              type: 'para',
              text: 'The registered documents will be returned to the authorised person by affixing the thump impression on the same day along with snapshot of the recorded video DVD in a pouch.'
            },
            { type: 'subheading', text: 'EXCEPTIONS:' },
            {
              type: 'list',
              items: [
                'If building is available then inspection for arriving at the market value of the property is to be carried out. If the building is approved and the copy of approval is given, inspection will not be carried out.',
                'Properties less than 10 cents in rural area and less than 20 cents in urban area are presented as Agricultural lands, then inspection will be carried out for checking whether it is house site or agricultural land.',
                'Non-payment(under value) of required duty or fee.',
                'Want of clarification on the nature of documents from District Registrar concerned.',
                'Verification of Power of Attorney as whether it is cancelled or in force if the Power of Attorney registered before 13-2-2018.',
                'If market value guidelines is having agricultural value and fixation of house site rate is warranted.',
                'Verification of genuine of Patta details in case of the property belongs to Natham land.'
              ]
            }
          ]
        },
        {
          heading: 'Field Inspection',
          blocks: [
            { type: 'subheading', text: 'Land Inspection' },
            {
              type: 'list',
              items: [
                'Value not available in the guideline register for that survey number.',
                'Conversion of agricultural land into house site.',
                'Sale of agricultural lands below 20 cents in case of urban areas and 10 cents in case of rural areas.',
                'House site suspected and the document bears agricultural value. Sub Registrar will fix the value after inspection.'
              ]
            },
            { type: 'subheading', text: 'Building Inspection When' },
            {
              type: 'list',
              items: [
                'When building approval not provided.',
                'When value of the building as stated by the parties exceeds Rs.50,000/- (in case of village).',
                'When value of the building as stated by the parties exceeds Rs.2,00,000/- (in case of Town panchayat, Municipality, Corporation).',
                'The sub Registrars will inspect the building and asses the value. If any difference in value is found out, the differential duty and a compounding fees will be collected. if not prepared for compounding, criminal prosecution will be initiated against the registrants.',
                'Suppressions of building in the property in order to evade payment of Stamp Duty may invite criminal proceeding.'
              ]
            }
          ]
        },
        {
          heading: 'Certified Copies',
          blocks: [
            {
              type: 'list',
              items: [
                'Anybody can apply for, pay the required fee and get certified copy of documents registered like Sale, Exchange, Mortgage etc.',
                'Copy of Will registered can be obtained only by the testator. After his demise, anybody can get copy.',
                'Copy of Power of Attorney document registered in Book 4 ie., registered before 1-12-2012 can be given only to the parties to the document or intended Purchaser.',
                'From the date of computerisation of particular Sub Registrar office to till date, application shall be submitted by online and the required payment also to be made by online (The system itself will show the required fees). The applied CC will be delivered to the user login with the QR code and digital signature of the Registering Officer within three working days excluding the application date.',
                'For getting CC before the date of computerisation of particular Sub Registrar office, manual application has to be given in the jurisdictional Sub Registrar office. The required fee can be paid either by online or using debit / credit card through the PoS machine kept in SR office. This application will be processed and signed CC will be delivered within 3 working days excluding the application date. Applications are available free of cost at Sub Registrar office. Give correct document number, year of registration and Sub Registrar office to get correct CC.'
              ]
            },
            { type: 'subheading', text: 'Fees:' },
            {
              type: 'table',
              columns: ['Item', 'Amount'],
              rows: [
                ['Application fees', 'Rs.1/-'],
                ['Search Fee for 1st year', 'Rs. 10/-'],
                ['For every addl. year', 'Rs. 5/-'],
                ['Computer Fees', 'Rs.200/-'],
                ['Copying Fees for copies made by Scanning Machine for the copy of Each Page', 'Rs.10'],
                ['Stamp Duty', 'Rs.20']
              ]
            },
            { type: 'subheading', text: 'HOLIDAY REGISTRATION:' },
            { type: 'para', text: 'WHEN? On application in special urgency. Fees: Rs. 1000/-' }
          ]
        }
      ]
    };

    // Tamil content is rendered as text blocks exactly as provided (light structuring only).
    const ta = {
      title: 'ஆவணங்கள் பதிவு செய்தல்',
      toc: [
        'வில்லங்கச்சான்று (EC)',
        'முத்திரைத் தீர்வை மற்றும் பதிவுக்கட்டண விகிதம்',
        'ஆவணம் தயாரித்தல்',
        'ஆவணத் தாக்கல்',
        'தேவைகள்',
        'ஆய்வு',
        'சான்றிட்ட நகல்கள்',
        'உயில்',
        'சிறப்பு வகை',
        'வழிகாட்டி சந்தை மதிப்பு',
        'போலிப்பதிவு – தீர்வு'
      ],
      intro:
        'அசையாச்சொத்து, வீடு போன்றவை வாங்குவது ஒவ்வொருவரின் கனவு ஆகும். ஒரு சொத்தினை வாங்குவதற்கு முன், முதற்கண் அச்சொத்து தொடர்பான பரிவர்த்தனைகளையும் சொத்தின் மீது உரிமைதாரரது உரிமையையும் அறிந்து கொள்ள வில்லங்கச்சான்றினை பெற வேண்டும்.',
      sections: [
        {
          heading: 'EC',
          blocks: [
            {
              type: 'list',
              items: [
                '1.1.1975 முதல் நாளது வரையான காலத்திற்கு வில்லங்கச்சான்றினை இணையதளத்திலிருந்து பதிவிறக்கம் செய்துக்கொள்ளலாம். இதில் ஒரு குறிப்பிட்ட சர்வே எண் தொடர்பான அனைத்து பரிவர்த்தனைகளையும் பார்வையிடலாம். இவை தகவலுக்காக மட்டுமே அளிக்கப்பட்டுள்ளது.',
                'பதிவு அலுவலரது மின்னொப்பமிட்ட வில்லங்கச்சான்று பெற வேண்டும் எனில், 1.1.1975 முதல் நாளது வரையான காலத்திற்கு விண்ணப்பம் இணையவழி அளிக்கப்பட வேண்டும் மற்றும் தேவையான கட்டணமும் இணையவழி செலுத்தப்படவேண்டும். (தேவையான கட்டண விவரம் காலத்தை பொறுத்து தானாகாவே கணக்கிட்டு காட்டப்படும்) விண்ணப்பித்த நாளினை தவிர்த்து மூன்று வேலை நாட்களுக்குள் பதிவு அலுவலரது மின்னொப்பத்துடனும் விரைவுக்குறியீட்டுடனும் (QR) வில்லங்கச்சான்று பயனரது உள்நுழைவிற்கு அனுப்பிவைக்கப்படும்.',
                'தெரிவு செய்யப்பட்ட கிராமமானது வெவ்வேறு சார்பதிவாளர் அலுவலகத்தில் வெவ்வேறு காலகட்டத்திற்குட்பட்டது எனில், சம்பந்தப்பட்ட சார்பதிவாளர் அலுவலகத்தில் அந்த கிராமம் இருந்த காலகட்டத்திற்கான வில்லங்கச்சான்றினை பெற தனித்தனியாக விண்ணப்பிக்க வேண்டும்.'
              ]
            }
          ]
        },
        {
          heading: 'விண்ணப்பத்திற்கான பட்டியல்',
          blocks: [
            {
              type: 'list',
              items: [
                'முகப்பு > பயனர் பதிவு > மின்னணு சேவைகள் > வில்லங்கச்சான்று > தேடுதல் மற்றும் வில்லங்கச்சான்று விண்ணப்பம்',
                '1.1.1975 காலத்திற்கு முந்தைய வில்லங்கச்சான்று பெறுவதற்கு (கையேட்டு முறை காலம்) விண்ணப்பத்தினை நேரிடையாக சம்பந்தப்பட்ட கிராம எல்லைக்குரிய சார்பதிவாளர் அலுவலகத்தில் அளிக்க வேண்டும். தேவையான கட்டணத்தை இணையவழி அல்லது சார்பதிவகத்தில் உள்ள குறுபணப்பரிவர்த்தனை இயந்திரத்தின் (PoS) வழி செலுத்திடலாம். இவ்விண்ணப்பமானது பரிசீலிக்கப்பட்டு பதிவு அலுவலரின் கையொப்பமிட்ட வில்லங்கச்சான்று 4 நாட்களுக்குள் கிடைக்கப்பெறும். சார்பதிவகங்களில் விண்ணப்பங்கள் இலவசமாக கிடைக்கப்பெறும். இணையதளத்திலிருந்தும் தேவையான படிவத்தினை பதிவிறக்கம் செய்துகொள்ளலாம். முகப்பு > மேலும் > இணைய முகப்பு பயன்பாட்டு சேவைகள் > பொது மக்கள் பயன்பாட்டு படிவங்கள்',
                'சொத்து தொடர்பான பரிவர்த்தனைகள் விடுதலின்றி வில்லங்கச்சான்றில் கிடைத்திட இயன்றவரை சொத்து குறித்து அதிகபட்ச விபரங்களை விண்ணப்பத்தில் அளித்திட வேண்டும்',
                'பொது மக்களால் அளிக்கப்படும் சார்பதிவகம், காலம், கிராமம், சர்வே எண்., உட்பிரிவு எண், புல எண்/பிளாட் எண். போன்ற விபரங்கள் பயன்படுத்தப்பட்டு வில்லங்கச்சான்றில் பரிவர்த்தனை விபரங்கள் தெரிவு செய்யப்பட்டு உருவாக்கப்படுகிறது. தவறான அல்லது போதுமான விபரங்கள் அளிக்கப்படவில்லை எனில், பரிவர்த்தனை விடுதல்களுடன் வில்லங்கச்சான்று அளிக்கப்படுவதற்கு வழிவகுக்கிறது. வில்லங்கச்சான்று விடுதல்களுடன் பெறப்பட்டு அதற்கான திருப்புத்தொகைக்கு விண்ணப்பிக்கப்படின் அவை ஏற்கப்பட மாட்டாது. உதாரணமாக, பொது மக்களால் புல எண். 5 என்பதற்கு பதில் 4 என அளிக்கப்படின், புல எண்.4க்குரிய வில்லங்கச்சான்று விபரங்களே அளிக்கப்படும்.'
              ]
            }
          ]
        },
        {
          heading: 'கட்டணம்',
          blocks: [
            {
              type: 'table',
              columns: ['விபரம்', 'தொகை'],
              rows: [
                ['வில்லங்கச்சான்று விண்ணப்ப கட்டணம்', 'Rs.1/-'],
                ['முதல் வருட தேடுதல் கட்டணம்', 'Rs.30/-'],
                ['ஒவ்வொரு கூடுதல் வருட தேடுதல் கட்டணம்', 'Rs. 10/-'],
                ['கணிணிமயமாக்கப்பட்ட காலத்திற்கான அதாவது 1975 முதலான கூடுதல் கட்டணம்', 'Rs.200/-']
              ]
            }
          ]
        },
        {
          heading: 'குறிப்பாணை',
          blocks: [
            {
              type: 'list',
              items: [
                '12.2.2018க்கு முன்னர், ஒரு அலுவலகத்தில் வெவ்வேறு எல்லைகளுக்குரிய இரு சொத்துக்கள் பதிவு செய்யப்படின், பதிவு செய்யப்பட்ட அலுவலகத்திலிருந்து மற்றொரு சொத்து அமையப்பெற்றுள்ள மற்றொரு அலுவலகத்திற்கு குறிப்பாணை அனுப்பப்படும். 12.2.2018 முதல் ஆவண விவரங்கள் இரு அலுவலகங்களிலும் ஆவணப்பதிவு நிறைவடைந்தவுடன் தாமாகவே வில்லங்கச்சான்றில் பிரதிபலிக்கும்'
              ]
            }
          ]
        },
        {
          heading: 'மூடப்பட்ட அலுவலகங்களுக்கான வில்லங்கச்சான்று',
          blocks: [
            {
              type: 'list',
              items: [
                'ஆவணப்பதிவு குறைவாக நடைபெற்ற சில சார்பதிவகங்கள் மூடப்பட்டன. இணையதளத்தில் அச்சார்பதிவாளர் அலுவலகத்தின் பெயரை தெரிவு செய்து 1.1.1975க்கு பிந்தைய காலத்திற்கு வில்லங்கச்சான்றுகளுக்கு விண்ணப்பிக்கலாம். 1.1.1975 முந்தைய காலத்திற்கு, மூடப்பட்ட அலுவலகத்தின் கிராமம் எந்த அலுவலகத்துடன் இணைக்கப்பட்டுள்ளதோ அந்த சார்பதிவகத்தில் வில்லங்கச்சான்று விண்ணப்பத்தினை அளித்திடலாம்.'
              ]
            }
          ]
        },
        {
          heading: 'முத்திரைத் தீர்வை மற்றும் பதிவுக்கட்டண விகிதம்',
          blocks: [
            {
              type: 'table',
              columns: ['ஆவண வகைப்பாடு', 'முத்திரைத்தீர்வை', 'பதிவுக் கட்டணம்'],
              rows: [
                ['1. விற்பனை ஆவணம்/கிரைய ஆவணம் (விற்பனை/கிரையம்)', '7% சந்தை மதிப்பிற்கு', '2% சந்தை மதிப்பிற்கு'],
                ['2. தான ஆவணம்', '7% சந்தை மதிப்பிற்கு', '2% சந்தை மதிப்பிற்கு'],
                ['3. பரிவர்த்தனை', 'அதிகபட்ச சொத்து மதிப்பிற்கு 7%', 'அதிகபட்ச சொத்து மதிப்பிற்கு 2%'],
                ['4. ஈடு அடமானம்', '1% (கடன் தொகைக்கு) உயர்ந்தபட்சம் Rs50,000/-', '1% (கடன் தொகைக்கு) உயர்ந்தபட்சம் Rs15,000/-'],
                ['5. ஈடு அடமானம் (சுவாதீனத்துடன் கூடியது)', '4% (கடன் தொகைக்கு)', '1% (கடன் தொகைக்கு) உயர்ந்தபட்சம் Rs.2,00,000/-'],
                ['6. விக்கிரைய உடன்படிக்கை', 'Rs.200', '1% (முன்பணத்திற்கு) சுவாதீனத்துடன் கூடிய விக்கிரைய உடன்படிக்கை எனில் கைமாற்றுத் தொகைக்கு 1%'],
                ['7. கட்டிட ஒப்பந்த உடன்படிக்கை', '1% ஒப்பந்த தொகைக்கு அல்லது ஆவணத்தில் குறிப்பிட்டுள்ள தொகை இவற்றில் அதிகமாக உள்ள தொகைக்கு', '3% ஒப்பந்த தொகைக்கு அல்லது ஆவணத்தில் குறிப்பிட்டுள்ள தொகை இவற்றில் அதிகமாக உள்ள தொகைக்கு'],
                ['8. ரத்து ஆவணம்', 'Rs.1000', 'Rs.500'],
                ['9. பாகப்பிரிவினை (வாரிசுரிமைப்படி கூட்டுரிமையாளர்கள்)', 'ஒவ்வொரு பாகத்திற்கும் சந்தை மதிப்பிற்கு 1% (அதிகபட்சம் ₹ 40,000/-)', 'ஒவ்வொரு பாகத்திற்கும் சந்தை மதிப்பிற்கு 1% (அதிகபட்சம் ₹ 10,000/-)'],
                ['9. பாகப்பிரிவினை (குடும்ப நபர் அல்லாதவர்களுக்கிடையில்)', 'பிரிந்த பாகத்தின் சந்தை மதிப்பிற்கு 4%', 'பிரிந்த பாகத்தின் சந்தை மதிப்பிற்கு 1%'],
                ['10. பொது அதிகாரம் விற்பனை செய்வதற்கு (குடும்ப நபர் அல்லாதவருக்கு)', 'சந்தை மதிப்பிற்கு 1%', 'சந்தை மதிப்பிற்கு 1%'],
                ['10. பொது அதிகாரம் விற்பனை செய்வதற்கு (குடும்ப நபருக்கு)', 'Rs. 2,000', 'Rs.2,000'],
                ['10. பொது அதிகாரம் விற்பனை தவிர இதர காரியங்களுக்கு', 'Rs. 1000', 'Rs.500'],
                ['10. பொது அதிகாரம் (கைமாற்று தொகையுடன்)', 'சந்தை மதிப்பிற்கு 5%', 'சந்தை மதிப்பிற்கு 1%'],
                ['11. தான செட்டில்மெண்ட் (குடும்ப நபருக்கு)', 'சந்தை மதிப்பிற்கு 1% (அதிகபட்சம் ரூ.40,000/-)', 'சந்தை மதிப்பிற்கு 1% (அதிகபட்சம் ரூ.10,000/-)'],
                ['11. தான செட்டில்மெண்ட் (குடும்ப நபர் அல்லாதவருக்கு)', '7% சந்தை மதிப்பிற்கு', '2% சந்தை மதிப்பிற்கு'],
                ['12. கூட்டு வணிகம் (மூலதனம் Rs.500க்குள்)', 'Rs. 500', '1% மூலதன தொகைக்கு'],
                ['12. கூட்டு வணிகம் (மூலதனம் Rs.500க்கு மேல்)', 'Rs. 2,000', '1% மூலதன தொகைக்கு'],
                ['13. உரிமை ஆவணங்களின் ஒப்படைப்பு', '0.5% கடன் தொகைக்கு அதிகபட்சம் ரூ.40,000/-', '1% கடன் தொகைக்கு அதிகபட்சம் ரூ.8,000/-'],
                ['14. விடுதலை (குடும்ப நபர்களுக் கிடையில்)', 'சந்தை மதிப்பிற்கு 1% (அதிகபட்சம் ரூ.40,000/-)', 'சந்தை மதிப்பிற்கு 1% (அதிகபட்சம் ரூ.10,000/-)'],
                ['14. விடுதலை (குடும்ப நபர் அல்லாவர்களுக் கிடையில்)', '7% சந்தை மதிப்பிற்கு', '1% சந்தை மதிப்பிற்கு'],
                ['15. குத்தகை 30 வருடத்திற்குள்', '1% கூடுதல் குத்தகை தொகைக்கு', '1% குத்தகை தொகைக்கு அதிகபட்சம் Rs.20000/-'],
                ['15. குத்தகை 99 வருடத்திற்குள்', '4% கூடுதல் குத்தகை தொகைக்கு', '1% குத்தகை தொகைக்கு அதிகபட்சம் Rs.20000/-'],
                ['15. குத்தகை 99 வருடத்திற்கு மேல்', '7% கூடுதல் குத்தகை தொகைக்கு', '1% குத்தகை தொகைக்கு அதிகபட்சம் Rs.20000/-'],
                ['16. நம்பக ஆவணம் (அசையா சொத்து இல்லாத நிலையில்)', 'Rs. 2,000', '1% கார்பஸ் நிதி']
              ]
            },
            { type: 'subheading', text: 'முத்திரைத் தீர்வை, பதிவுக்கட்டணங்களை செலுத்தும் வழி முறைகள்' },
            {
              type: 'list',
              items: ['வழக்கமான முத்திரைத்தாட்கள்', 'மின் முறையில் பணம் செலுத்துகை']
            },
            { type: 'subheading', text: 'முத்திரை' },
            {
              type: 'list',
              items: [
                'இணையதளத்தில் முத்திரைகள் விற்பனை செய்யக்கூடிய உரிமம் பெற்ற',
                'அவர்கள் முக மதிப்பிலான முத்திரைகளை விற்பனை செய்வதற்கு உரிமம் பெற்றவர்கள்',
                'கூடுதலாக கோரப்படின், அன்னாரது உரிமத்தினை ரத்து செய்வதற்கு நடவடிக்கை எடுக்கப்படும்',
                'சார்பதிவாளர்கள், கருவூலங்கள் மற்றும் சென்னை உதவி கண்காணிப்பாளர்கள் (முத்திரை) அவர்களாலும் முத்திரைத்தாட்கள் விற்பனை செய்யப்படும்',
                'எவ்வித உச்சவரம்பின்றி இணையவழி முத்திரைத்தீர்வை செலுத்திடலாம் அல்லது ரூ.5000/- வரை வங்கி வரைவோலை மூலம் செலுத்திடலாம். இணையவழியில் RTGS/NEFT மூலமும் முத்திரைத்தீர்வை செலுத்திடுவதற்கான விருப்பத் தெரிவு முறைகள் உள்ளன. இணையதளத்தில் இணையவழி பணம் செலுத்துகை திரையில், பயனரால் RTGS/NEFT விருப்பத் தெரிவு முறையினை தேர்வு செய்திட வேண்டும். ஒரு செலான் உருவாக்கப்பெற்று இதனை பயன்படுத்தி தங்களது வங்கியிடம் தொகையினை மாற்றம் செய்திட தெரிவித்திடலாம். தொகை மாற்றப்பட்டவுடன், பயனரால் பதிவுத்துறையின் இணையதளத்திலிருந்து ஒப்புகை பெறலாம்',
                'சென்னை மண்டல மற்றும் ஏனைய மாநகராட்சி பகுதிகளின் ஆவணப்பதிவிற்கு மின்னணு பதிப்பு முறையினையும் பயன்படுத்திக்கொள்ளலாம்.'
              ]
            }
          ]
        },
        {
          heading: 'ஆவணம் தயாரித்தல்',
          blocks: [
            { type: 'subheading', text: 'வரைவு ஆவணம் தயாரித்தல்:' },
            {
              type: 'list',
              items: [
                'ஆவணம் தாக்கல் செய்பவர்: பொது மக்கள் பதிவுத்துறை இணையதளத்தில் உள்ள ஆவண உருவாக்க வசதியினை அல்லது பதிவுத்துறை இணையதளத்தில் உள்ள மாதிரி ஆவணங்களையும் பயன்படுத்திக்கொள்ளலாம்',
                'வழக்கறிஞர்கள்.',
                'உரிமம் பெற்ற ஆவண எழுத்தர்கள்',
                'ஆவண எழுத்தர் உரிமம் பெற்ற பட்டயக்கணக்காளர்கள்',
                'கட்டணங்கள் செலுத்தப்படும் அனைத்திற்கும் ரசீதினைக் கேட்டுப்பெறலாம். பதிவுப்பணி நிறைவுற்றதும், குறிப்பு ஆவணமாக இது ஒளிவருடல் செய்யப்படும்.'
              ]
            },
            { type: 'subheading', text: 'ஆவணச்சுருக்கம் உள்ளீடு' },
            {
              type: 'list',
              items: [
                'இணையதளத்தில் உள்ள வசதியினை பயன்படுத்தாமல் ஆவணம் உருவாக்கப்படின், தாக்கல் செய்பவர், எழுதி பெறுபவர், சொத்து விவரம் போன்ற முக்கிய விவரங்கள் இணையதளத்தில் உள்ளீடு செய்யப்பட வேண்டும்'
              ]
            },
            { type: 'subheading', text: 'டோக்கன்கள் பதிவு' },
            {
              type: 'list',
              items: [
                'பணம் செலுத்தப்பட்டவுடன், சம்பந்தப்பட்ட சார்பதிளரிடம் இணையவழி முன்பதிவு ஒதுக்கீடு செய்து கொள்ளலாம். கீழ்ககண்ட பட்டியலில் டோக்கன் கிடைப்பதனை பார்வையிட இயலும்:'
              ]
            }
          ]
        },
        {
          heading: 'ஆவணத் தாக்கல்',
          blocks: [
            { type: 'subheading', text: 'ஆவணத்தாக்கல் எப்போது?' },
            {
              type: 'list',
              items: [
                'எழுதிக்கொடுத்த தேதியிலிருந்து 4 மாதங்களுக்குள்',
                'மாவட்டப்பதிவாளர் மேலும் நான்கு மாதங்களுக்கு தாமதத்திற்கான அபராதத்துடன் மன்னித்து ஆணையிடலாம்',
                'உயில் ஆவணத்திற்கு காலக்கெடு ஏதுமில்லை.'
              ]
            },
            { type: 'subheading', text: 'அபராதம்' },
            {
              type: 'table',
              columns: ['வ.எண்..', 'தாமதம்', 'அபராதம்'],
              rows: [
                ['1', 'ஒரு வாரத்திற்கு', 'பதிவுக்கட்டணத்தில் 25%'],
                ['2', 'ஒரு மாதத்திற்கு', 'பதிவுக்கட்டணத்தில் 75%'],
                ['3', 'நான்கு மாதங்களுக்கு', 'பதிவுக்கட்டணத்தில் 100%']
              ]
            },
            { type: 'para', text: 'தேவையான பதிவுக்கட்டணத்துடன் இது கூடுதல் கட்டணமாகும்' },
            { type: 'subheading', text: 'ஆவணத்தை பதிவுக்கு தாக்கல் செய்வது?' },
            {
              type: 'list',
              items: [
                'தமிழ்நாட்டில் உள்ள அசையாச்சொத்துக்குரிய ஆவணங்கள், சொத்து அமைந்துள்ள எல்லைக்குரிய சார்பதிவாளர் அலுவலகத்தில் மட்டுமே பதிவு செய்ய இயலும்',
                'அசையாச்சொத்துக்களுக்கான பொது அதிகார ஆவணமானது சொத்து அமைந்துள்ள எல்லைக்குரிய சார்பதிவாளர் அலுவலகத்திலோ அல்லது முதல்வரது இருப்பிட எல்லைக்குரிய சார்பதிவாளர் அலுவலகத்திலோ தாக்கல் செய்திடலாம்',
                'ஒரு ஆவணத்தில் ஒன்றுக்கு மேற்பட்ட சொத்து இருப்பின், சொத்துக்கள் அமைந்துள்ள எல்லைக்குரிய ஏதாவது ஒரு சார்பதிவாளர் அலுவலகத்தில் பதிவு செய்திடலாம்',
                'பொது அதிகாரம் தவிர்த்து தமிழ்நாட்டில் உள்ள சொத்துக்களுக்கு வெளிமாநிலங்களில் பதிவு செய்யப்படுவது சட்டப்படி செல்லத்தக்கதல்ல.',
                'சம்பந்தப்பட சார்பதிவாள்ர் எல்லையை அறிய இணையதளத்தில் உங்கள் எல்லை அறிந்திடும் பட்டியிலில் தெரு பெயர் அல்லது கிராமப்பெயர் உள்ளீடு செய்வதன் மூலம் பதிவு அலுவலக எல்லை விவரம் அறிந்திடலாம்'
              ]
            }
          ]
        },
        {
          heading: 'தேவைகள்',
          blocks: [
            {
              type: 'list',
              items: [
                'சரியான முறையில் தாக்கலாகும் ஆவணம். கிரைய ஆவணம் பொருத்து கிரைய ஆவணத்தை எழுதி வாங்குபவரும் கிரைய ஆவணத்தில் கையொப்பமிட வேண்டும். மேலும் கிரைய ஆவணப்பதிவிற்கு, பதிவு அலுவலர் முன் ஆஜராக வேண்டும்.',
                'அசையாச் சொத்துக்களின் கிரையம், ஈடு, தானம், பரிவர்த்தனை, பாகம், விடுதலை மற்றும் கிரைய சான்று மற்றும் சொத்தானது மனை நத்தமாக இருப்பின், ரூ.7/- நீதி மன்ற ஒட்டு வில்லையுடன் கூடிய பூர்த்தி செய்ப்பட்ட மற்றும் கையொப்பமிடப்பட்ட பட்டா மாற்ற விண்ணப்பத்தினை அளித்திட வேண்டும்.',
                'ரூ.10 லட்சத்திற்கு மேற்பட்ட மதிப்பிலான சொத்துக்களுக்கு, PAN/படிவம் 60 அளிக்கப்பட வேண்டும்',
                'தேவையான பதிவுக்கட்டணம், கணினி கட்டணம், உட்பிரிவு கட்டணம் போன்றவைகள் இணையவழி செலுத்திய ஒப்புகைச் சீட்டு. ஏதேனும் கட்டணத்தொகை ரூ.1000/-க்குள் செலுத்த வேண்டி இருப்பின், சார்பதிவாளர் அலுவலகத்தில் உள்ள PoS இயந்திரத்தில், பற்று அல்லது கடன் அட்டை மூலம் செலுத்திடலாம்.',
                'சொத்து நத்தம் வகை மனையாக இருப்பின், வருவாய் அதிகாரிகளால் அளிக்கப்பட்ட பட்டா',
                'ஆவணம் தாக்கல் செய்பவர், ஆவணம் எழுதி பெறுபவர் மற்றும் சாட்சிகளது (கிரைய ஆவணங்களுக்கு) அசல் ஆளறி சான்று. அசல் ஆவணத்துடன் மேற்காண் அனைவரது ஆளறி சான்றுகளின் நகல்கள் இணைக்கப்படவேண்டும். ஆதார் அட்டை, PAN அட்டை, வாக்காளர் அட்டை, ஓட்டுநர் உரிமம், கடவுச்சீட்டு, ரேஷன் கார்டு ஆகியன மட்டுமே ஆளறி சான்றுகளாக அங்கீகரிக்கப்படும்',
                'கிரையம், ஈடு, தானம், பரிவர்த்தனை, பாகம், விடுதலை மற்றும் கிரைய சான்று ஆவணங்களைப் பொறுத்து சொத்து மனைப்பிரிவாக இருப்பின், மனைப்பிரிவின் வரைபடம். முதல் மனை ஆவணமாகவும் மறு விற்பனை இல்லாததாகவும் இருப்பின், CMDA அல்லது DTCP-ஆல் அளிக்கப்பட்ட அங்கீகரிக்கப்பட்ட அல்லது முறைபடுத்தப்பட்ட ஆணை நகல்.',
                'அசல் முன் ஆவணம், இல்லையெனில், காவல் துறையினரால் அளிக்கப்படும் கண்டறியா சான்று மற்றும் இது குறித்து நாளிதழில் அளிக்கப்பட்டுள்ள விளம்பரம்.',
                'சொத்து உரிமைதாரர் உயிருடன் இல்லை எனில், அன்னாரது இறப்பு சான்றிதழ் மற்றும் வாரிசு சான்றிதழ்'
              ]
            },
            { type: 'subheading', text: 'ஆவணம் திரும்பப்பெறுதல் :' },
            {
              type: 'para',
              text: 'பதிவுற்ற ஆவணங்கள் உரிய பெருவிரல் ரேகைப்பதிவு இடப்பட்ட நபரிடம் அன்றே ஒரு காதித பையில் பதிவு செய்யப்பட்ட ஒளி பிம்ப காட்சிகள் அடங்கிய நெகிழ்வட்டுடன் திரும்ப அளிக்கப்படும்'
            },
            { type: 'subheading', text: 'அன்றே திரும்ப அளித்திடுவதிலிருந்து விலக்களிக்கப்பட்டவை:' },
            {
              type: 'list',
              items: [
                'கட்டடம் இருப்பின், சொத்தின் சந்தை மதிப்பினை அறிந்திட ஆய்வு மேற்கொள்ளப்பட வேண்டும். கட்டணம் அங்கீகரிக்கப்பட்டிருப்பின், அங்கீகரிக்கப்பட்ட நகல் அளிக்கப்படின், ஆய்வு மேற்கொள்ளப்பட மாட்டாது',
                'கிராமப்புற சொத்துக்கள் 10 செண்ட்டுக்கு குறைவானதாக இருப்பின், நகர்ப்புற சொத்துக்கள் 20 செண்ட்டுக்கு குறைவானதாகவும் விவசாய நிலமாக அளிக்கப்படின், வீட்டு மனையா அல்லது விவசாய நிலமா என கண்டறிய ஆய்வு மேற்கொள்ளப்படும்',
                'தேவையான முத்திரை அல்லது பதிவு கட்டணம் செலுத்தப்படாமை (மதிப்புக்குறைவு)',
                'உரிய மாவட்டப்பதிவாளரிடமிருந்து ஆவணத்தன்மை குறித்து தெளிவுரை வேண்டியிருப்பின்',
                '13.2.2018க்கு முன்னர் பதிவு செய்யப்பட்ட பொது அதிகார ஆவணம் பொருத்து பொது அதிகாரம் ரத்து செய்யப்பட்டதா அல்லது அமலில் உள்ளதா என சரிபார்த்தல்',
                'வழிகாட்டி சந்தை மதிப்பில் விவசாய மதிப்பு இருந்து மனை மதிப்பு நிர்ணயம் வேண்டியிருப்பின்',
                'சொத்து நத்தம் மனையாக இருப்பின் பட்டா மெய்த்தன்மை சரிபார்த்திட'
              ]
            }
          ]
        },
        {
          heading: 'ஆய்வு',
          blocks: [
            { type: 'subheading', text: 'ஆய்வு எப்போது ?' },
            {
              type: 'list',
              items: [
                'சர்வே எண்ணுக்குரிய மதிப்பு வழிகாட்டிப்பதிவேட்டில் இல்லையெனில்',
                'விவசாய நிலம் மனையாக மாற்றப்படும் போது',
                'கிராமப்புற சொத்துக்கள் 10 செண்ட்டுக்கு குறைவானதாக, நகர்ப்புற சொத்துக்கள் 20 செண்ட்டுக்கு குறைவானதாக இருப்பின்',
                'சந்தேகத்திற்குரிய மனையிடங்கள் மற்றும் ஆவணத்தில் விவசாய மதிப்பு உள்ளவை. சார்பதிவாளரால் ஆய்விற்கு பின் மதிப்பு நிர்ணயிக்கப்படும்.'
              ]
            },
            { type: 'subheading', text: 'கட்டிட ஆய்வு எப்போது ?' },
            {
              type: 'list',
              items: [
                'கட்டட அங்கீகாரம் அளிக்காமல் இருப்பின்',
                'ரூ.50,000/-க்கு மேல் கட்டட மதிப்பு அளிக்கப்பட்டிருப்பின் (கிராமப்புறம்)',
                'ரூ.2,00,000/-க்கு மேல் கட்டட மதிப்பு அளிக்கப்பட்டிருப்பின் (நகர்ப்புறம், நகராட்சி, மாநகராட்சி)',
                'சார்பதிவாளர்கள் கட்டிடத்தினை ஆய்வு செய்து மதிப்பினை கண்டறிவார். வேறுபாடு கண்டறியப்படின், வித்தியாச தீர்வை, இணக்கக்கட்டணம் வசூலிக்கப்படும். இணக்கக் கட்டணம் செலுத்திடவில்லையெனில், ஆவணதாரரின் மீது குற்றவியல் வழக்கு தொடரப்படும்.',
                'முத்திரைத் தீர்வை செலுத்திடுவதைத் தவிர்க்க சொத்தின் கட்டட மதிப்பு மறைக்கப்படின், குற்றவியல் நடவடிக்கை மேற்கொள்ளப்படும்'
              ]
            }
          ]
        },
        {
          heading: 'சான்றிட்ட நகல்கள்',
          blocks: [
            {
              type: 'list',
              items: [
                'கிரையம், பரிவர்த்தனை, அடமானம் போன்ற ஆவணங்களுக்கான சான்றிட்ட நகல்களை யார் வேண்டுமானாலும் விண்ணப்பித்து, தேவையான கட்டணம் செலுத்தி அளித்து பெறலாம்.',
                'உயிலிற்கான நகலினை ஆவணம் எழுதி வைத்தவர் மட்டுமே பெற இயலும்.',
                'அவர் இறந்தபின், யார் வேண்டுமாலும் நகல் பெறலாம்.',
                'புத்தகம் 4ல் பதிவு செய்யப்பட்ட பொது அதிகார ஆவணங்களைப் பொருத்து அதாவது 1.12.2012க்கு முன் பதியப்பட்டவை பொருத்து எழுதிக்கொடுத்தவர், எழுதி வாங்கியவர் மற்றும் பின்னாளில் சொத்தின் மீது உரிமைப்பெற்றவர் மட்டுமே பெற இயலும்',
                'ஒரு சார்பதிவகம் கணிணிமயமாக்கப்பட்ட நாளிலிருந்து நாளதுவரை, இணையவழி விண்ணப்பங்கள் அளிக்கப்பட்டும் இணையவழியே தேவையான தொகையினையும் செலுத்திடலாம் (கணினிவழியே தேவையான கட்டணம் தோன்றும்). விண்ணப்பிக்கப்பட்ட சான்றிட்ட நகலானது பயனாளரது உள்நுழைவிற்கு விரைவு குறியீட்டுடனும் (QR) பதிவு அலுவலரது இலக்கமயமாக்கப்பட்ட கையொப்பத்துடனும் விண்ணப்பித்த நாளினை தவிர்த்து 3 வேலை நாட்களுக்குள் அனுப்பிவைக்கப்படும்.',
                'சான்றிட்ட நகல் விண்ணப்பிப்பதற்கான பட்டியல்: முகப்பு > மின்னணு சேவைகள் > சான்றிட்ட நகல் > தேடுதல் மற்றும் சான்றிட்ட நகல் விண்ணப்பித்தல்',
                'ஒரு சார்பதிவகத்தின் கணினிமயமாக்கப்பட்ட காலத்திற்கு முந்தைய காலத்திற்கான சான்றிட்ட நகல் பெற வேண்டுமெனில், சம்பந்தப்பட்ட சார்பதிவாளர் அலுவலகத்தில் நேரடியாக விண்ணப்பம் அளிக்க வேண்டும். தேவையான கட்டணத்தினை இணையவழியாகவோ அல்லது சார்பதிவாளர் அலுவலகத்தில் உள்ள PoS இயந்திரத்தின்வழி பற்று/கடன் அட்டை பயன்படுத்தியோ செலுத்திடலாம். இவ்விண்ணப்பமானது பரிசீலிக்கப்பட்டு கையொப்பமிட்ட சான்றிட்ட நகலானது விண்ணப்பிக்கும் தேதி தவிர்த்து மூன்று வேலை நாட்களுக்குள் அனுப்பிவைக்கப்படும். இதற்கான விண்ணப்பத்தை சார்பதிவாளர் அலுவலகத்தில் இலவசமாக பெறலாம். மேலும் தேவையான படிவத்தினை பதிவிறக்கம் கீழ்க்கண்ட வழிமுறையில் தரவிறக்கம் செய்து கொள்ளலாம். முகப்பு > மேலும் > இணைய முகப்பு பயன்பாட்டு சேவைகள் > பொது மக்கள் பயன்பாட்டு படிவங்கள்',
                'சரியான சான்றிட்ட நகலினை பெற சரியான ஆவண எண், பதிவு தேதி மற்றும் சார்பதிவாளர் அலுவலகம் அளித்திட வேண்டும்'
              ]
            },
            { type: 'subheading', text: 'கட்டணம்:' },
            {
              type: 'table',
              columns: ['விபரம்', 'தொகை'],
              rows: [
                ['விண்ணப்பக் கட்டணம்', 'ரூ.1/-'],
                ['முதல் வருடத்திற்கான தேடுதல் கட்டணம்', 'Rs. 10/-'],
                ['ஒவ்வொரு கூடுதல் வருடத்திற்கும்', 'ரூ. 5/-'],
                ['”ஸ்டார் திட்டம்” வழி', 'கூடுதல் கட்டணம் ரூ.200/-'],
                ['நகல் கட்டணம் (கணினி மூலமாக ஒவ்வொரு பக்கத்திற்கும்)', 'ஒரு பக்கத்திற்கு ரூ.10/-'],
                ['முத்திரைத்தீர்வை', 'ரூ. 20/-']
              ]
            }
          ]
        },
        {
          heading: 'ஆவணம் போலியாக பதிவு செய்யப்பட்டிருப்பின் தீர்வுகள்',
          blocks: [
            {
              type: 'list',
              items: [
                'பதிவு செய்யப்பட்ட ஆவணமானது தகுதி வாய்ந்த சிவில் நீதி மன்றத்தாலேயே ரத்து செய்ய இயலும்.',
                'உரிய சுற்றறிக்கைகளை கடைபிடிக்காமல் சார்பதிவாளரால் தவறாக பதிவு மேற்கொள்ளப்பட்டிருப்பின், அதனால் பாதிக்கப்பட்ட பொது மக்கள் உரிய மாவட்டப்பதிவாளரிடம் புகாரினை அளித்திடலாம்.',
                'பதிவுத்துறைத்தலைவர் சுற்றறிக்கை எண்.41530/யு1/2017 நாள்:8.11.2017ன்படி மாவட்டப்பதிவாளர் இரு தரப்பினரிடமும் விசாரணை மேற்கொண்டு விரிவான ஆணை பிறப்பித்திடுவார்.',
                'அவ்வாணையின் சுருக்கமானது வில்லங்கச்சான்றிதழிலும் உள்ளடக்கப்பட்டிருக்கும். அவ்வாணையின் அடிப்படையில், உரிய உரிமையாளர் பின் பதிவு மேற்கொள்ள அனுமதிக்கப்படுவர்.',
                'மாவட்டப்பதிவாளரது ஆணையினை எதிர்த்து உரிய துணைபதிவுத்துறைத்தலைவரிடம் மேல்முறையீடு செய்து கொள்ளலாம்.',
                'ஆள்மாறாட்டம், ஒரே சொத்தினை இரு நபர்களுக்கு விற்றல், பரிவர்த்தனைகளில் தவறான தகவல்கள் அளித்திடுதல், தகுதியற்ற பொது அதிகார முகவரால் சொத்து பரிமாற்றம் போன்றவற்றினை ஆராய்ந்து அதன் அடிப்படையில் ஆணைகள் பிறபிக்கப்படும். நீதிமன்றங்களால் தீர்த்து வைக்கபப்ட வேண்டிய சொத்து தொடர்பான தகராறுகள் இத்துறையால் கையாளப்படுவதில்லை.'
              ]
            }
          ]
        }
      ]
    };

    return { en, ta };
  }, []);

  const active = lang === 'ta' ? content.ta : content.en;

  const renderBlock = (block, idx) => {
    if (block.type === 'para') {
      return (
        <p key={idx} className="howtodo-para">
          {block.text}
        </p>
      );
    }
    if (block.type === 'subheading') {
      return (
        <h4 key={idx} className="howtodo-subheading">
          {block.text}
        </h4>
      );
    }
    if (block.type === 'list') {
      return (
        <ul key={idx} className="howtodo-list">
          {block.items.map((it) => (
            <li key={it}>{it}</li>
          ))}
        </ul>
      );
    }
    if (block.type === 'table') {
      return (
        <div key={idx} className="table-responsive">
          <table className="table table-bordered table-striped align-middle howtodo-table">
            <thead className="table-light">
              <tr>
                {block.columns.map((c) => (
                  <th key={c} scope="col">
                    {c}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row) => (
                <tr key={row.join('|')}>
                  {row.map((cell) => (
                    <td key={cell}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="howtodo-page">
      <Header />
      <main className="howtodo-main">
        <Container fluid="xxl" className="py-4 px-3 px-md-5">
          <div className="howtodo-card shadow-lg">
            <div className="howtodo-header">
              <div className="howtodo-title-wrap">
                <h2 className="howtodo-title">{active.title}</h2>
                <p className="howtodo-intro">{active.intro}</p>
              </div>

              <div className="howtodo-lang-toggle">
                <div className="howtodo-toggle-labels">
                  <span className={lang === 'en' ? 'active' : ''}>English</span>
                  <span className={lang === 'ta' ? 'active' : ''}>தமிழ்</span>
                </div>
                <Form.Check
                  type="switch"
                  id="howtodo-lang-switch"
                  checked={lang === 'ta'}
                  onChange={(e) => setLang(e.target.checked ? 'ta' : 'en')}
                  label={lang === 'ta' ? 'தமிழ்' : 'English'}
                />
              </div>
            </div>

            <section className="howtodo-section">
              <h3 className="howtodo-section-title">{lang === 'ta' ? 'உள்ளடக்கம்' : 'Contents'}</h3>
              <ul className="howtodo-toc">
                {active.toc.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
            </section>

            {active.sections.map((sec) => (
              <section key={sec.heading} className="howtodo-section">
                <h3 className="howtodo-section-title">{sec.heading}</h3>
                {sec.blocks.map((b, idx) => renderBlock(b, idx))}
              </section>
            ))}
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default HowToDo;

